import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'uikit/Container/Container';
import i18nContext from 'components/i18n-context';
import { ReactComponent as LockIcon } from 'assets/lock-permission.svg';
import BackButton from 'components/BackButton';
import './DontHavePermission.scss';

export const DontHavePermission = ({ headerText, showBackButton = false }) => {
  const i18n = useContext(i18nContext);

  return (
    <section className={'right-section dont-permission'}>
      <Container header={headerText}>
        <div className={'dont-permission-wrapper'}>
          <LockIcon className={'dont-permission-icon'} />
          <p className={'dont-permission-text'}>
            {showBackButton ? i18n.getMessage('forbidden.page.description') : i18n.getMessage('noPermission.text')}
          </p>
          {showBackButton && (
            <div className={'dont-permission-back-button'}>
              <BackButton usePreviousRoute={true} />
            </div>
          )}
        </div>
      </Container>
    </section>
  );
};

DontHavePermission.propTypes = {
  headerText: PropTypes.string,
  showBackButton: PropTypes.bool
};
